import React from 'react'
import EditOffer from './EditOffer'
import MaintenanceSummary from './MaintenanceSummaryPage'
import OfferApprovals from './OfferApprovalListPage'
import OfferParticipation from './OfferParticipationListPage'
import OfferSourcingDecisions from './OfferSourcingDecisionListPage'
import OfferVendorRFQs from './OfferVendorRFQListPage'

import { OfferStage, OfferType } from '../constants'
import { MenuSubGroup } from '@/features/systemVariables/constants'
import MyOfferPage from './MyOfferPage'
import OfferListPage from './OfferListPage'
import OfferPRApprovalListPage from './OfferPRApprovalListPage'
import OfferTaskDashboard from './OfferTaskDashboard'
import MySourcingPage from './MySourcingPage'
import OfferGCPRApprovalListPage from './OfferGCPRApprovalListPage'
import OfferGCPRMaterialListPage from './OfferGCPRMaterialListPage'

const OfferBreadcrumb = () => <>{`Offer Detail`}</>

const offerRoutes = [
  {
    breadcrumb: 'My Offers',
    path: 'my',
    element: <MyOfferPage />,
  },
  {
    breadcrumb: 'My Sourcing',
    path: 'mySourcing',
    element: <MySourcingPage />,
  },
  {
    breadcrumb: 'Offer (Maintenance)',
    path: 'offerMaintenance',
    element: <OfferListPage offerStage={OfferStage.QUOTATION} offerType={OfferType.MAINTENANCE} isEQuotation={false} />,
  },
  {
    breadcrumb: 'Offer (Project)',
    path: 'offerProject',
    element: <OfferListPage offerStage={OfferStage.QUOTATION} offerType={OfferType.PROJECT} isEQuotation={false} />,
  },
  {
    breadcrumb: 'Offer (eQuotation - End Customer)',
    path: 'offerEQuotationEndCustomer',
    element: (
      <OfferListPage
        offerStage={OfferStage.QUOTATION}
        menuSubGroup={MenuSubGroup.EQUOTATION_END_CUSTOMER}
      />
    ),
  },
  {
    breadcrumb: 'Offer (eQuotation - Tenant)',
    path: 'offerEQuotationTenant',
    element: (
      <OfferListPage offerStage={OfferStage.QUOTATION} menuSubGroup={MenuSubGroup.EQUOTATION_TENANT} />
    ),
  },
  {
    breadcrumb: 'Offer (eQuotation - Product)',
    path: 'offerEQuotationProduct',
    element: (
      <OfferListPage offerStage={OfferStage.QUOTATION} menuSubGroup={MenuSubGroup.EQUOTATION_PRODUCT} />
    ),
  },
  // Legacy path kept so old bookmarks still open End Customer eQuotation
  {
    breadcrumb: 'Offer (eQuotation - End Customer)',
    path: 'offerProjectEQuotation',
    element: (
      <OfferListPage
        offerStage={OfferStage.QUOTATION}
        menuSubGroup={MenuSubGroup.EQUOTATION_END_CUSTOMER}
      />
    ),
  },

  {
    breadcrumb: 'Booking (Maintenance)',
    path: 'bookingMaintenance',
    element: <OfferListPage offerStage={OfferStage.BOOKING} offerType={OfferType.MAINTENANCE} isEQuotation={false} />,
  },
  {
    breadcrumb: 'Booking (Project)',
    path: 'bookingProject',
    element: <OfferListPage offerStage={OfferStage.BOOKING} offerType={OfferType.PROJECT} isEQuotation={false} />,
  },
  {
    breadcrumb: 'Booking (eQuotation - End Customer)',
    path: 'bookingEQuotationEndCustomer',
    element: (
      <OfferListPage
        offerStage={OfferStage.BOOKING}
        menuSubGroup={MenuSubGroup.EQUOTATION_END_CUSTOMER}
      />
    ),
  },
  {
    breadcrumb: 'Booking (eQuotation - Tenant)',
    path: 'bookingEQuotationTenant',
    element: (
      <OfferListPage offerStage={OfferStage.BOOKING} menuSubGroup={MenuSubGroup.EQUOTATION_TENANT} />
    ),
  },
  {
    breadcrumb: 'Booking (eQuotation - Product)',
    path: 'bookingEQuotationProduct',
    element: (
      <OfferListPage offerStage={OfferStage.BOOKING} menuSubGroup={MenuSubGroup.EQUOTATION_PRODUCT} />
    ),
  },
  {
    breadcrumb: 'Booking (eQuotation - End Customer)',
    path: 'bookingProjectEQuotation',
    element: (
      <OfferListPage
        offerStage={OfferStage.BOOKING}
        menuSubGroup={MenuSubGroup.EQUOTATION_END_CUSTOMER}
      />
    ),
  },

  {
    breadcrumb: 'Approvals',
    path: 'approvals',
    element: <OfferApprovals />,
  },

  {
    breadcrumb: 'Maintenance Summary',
    path: 'maintenanceSummary',
    element: <MaintenanceSummary />,
  },
  {
    breadcrumb: 'My Offers',
    path: 'participations',
    element: <OfferParticipation />,
  },
  {
    breadcrumb: 'Sourcing Decisions',
    path: 'sourcingDecisions',
    element: <OfferSourcingDecisions />,
  },
  {
    breadcrumb: 'Vendor RFQs',
    path: 'vendorRFQs',
    element: <OfferVendorRFQs />,
  },
  {
    breadcrumb: 'PR Approvals',
    path: 'pr-approvals',
    element: <OfferPRApprovalListPage />,
  },
  {
    breadcrumb: 'GCPR Approvals',
    path: 'gcpr-approvals',
    element: <OfferGCPRApprovalListPage />,
  },
  {
    breadcrumb: 'GCPR Materials',
    path: 'gcpr-materials',
    element: <OfferGCPRMaterialListPage />,
  },
  {
    breadcrumb: '',
    path: 'tasks',
    element: <OfferTaskDashboard />,
  },

  {
    breadcrumb: OfferBreadcrumb,
    path: ':id',
    element: <EditOffer />,
  },
]

export default offerRoutes
